import { RestaurantCardSkeleton } from "@/components/RestaurantCardSkeleton";
import { useFilteredRestaurants } from "@/hooks/useFilteredRestaurants";
import { RestaurantListContent } from "./restaurant-list/RestaurantListContent";
import { RestaurantListError } from "./restaurant-list/RestaurantListError";
import { RestaurantListEmpty } from "./restaurant-list/RestaurantListEmpty";
import { useToast } from "@/hooks/use-toast";
import type { FilterParams } from "@/types/filters";

interface RestaurantListProps {
  filters: FilterParams;
}

export const RestaurantList = ({ filters }: RestaurantListProps) => {
  const { toast } = useToast();
  const { 
    data: restaurants = [], 
    isLoading, 
    error,
    isError,
    isFetching 
  } = useFilteredRestaurants(filters);

  // Improved error logging and user notification
  if (isError && error instanceof Error) {
    console.error('RestaurantList - Error:', error);
    toast({
      title: "Error loading restaurants",
      description: "Please try again later",
      variant: "destructive",
    });
    return <RestaurantListError />;
  }

  if (isLoading || isFetching) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 animate-in fade-in-50">
        {Array.from({ length: 6 }).map((_, index) => (
          <RestaurantCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (restaurants.length === 0) {
    return <RestaurantListEmpty />;
  }

  return <RestaurantListContent restaurants={restaurants} />;
};